import DeactivateButton from "./DeactivateButton";

export default DeactivateButton;
